var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"router-block",style:({height:(this.$store.state.windowHeight-this.$store.state.blockNavHeight-this.$store.state.topBlockHeight-this.$store.state.indexPadding*2)+"px"})},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }